import { forwardRef } from 'react';
import cn from 'classnames';

import s from './BaseListItem.scss';

interface Props {
  className?: string;
  isSelected?: boolean;
  isDragging?: boolean;
}

const BaseListItem = forwardRef<
  HTMLLIElement,
  React.PropsWithChildren<Props>
>(({ className, isSelected, isDragging, children }, ref) => (
  <li
    className={cn(
      s['list-item'],
      isSelected && s['selected'],
      isDragging && s['dragging'],
      className
    )}
    ref={ref}
  >
    {children}
  </li>
));
BaseListItem.displayName = 'BaseListItem';

export default BaseListItem;
